import { render, staticRenderFns } from "./SwitchHorizontalDuotone01.vue?vue&type=template&id=2ec0aea4&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports